module.exports = __webpack_public_path__ + "static/media/AdobeXdIcon.9882f2ff.svg";